class Slider {

    constructor() {
        this.addListeners()
        this.addAtlasBanners()
    }

    addAtlasBanners() { 
        const slider = document.getElementById('bannersSlider');

        if (slider) {
            const slides = slider.querySelectorAll('.banners-item');
            const dots = slider.querySelectorAll('.control-item');           
            const next = slider.querySelector('.next');
            const prev = slider.querySelector('.prev')
            
            window.addEventListener('resize', () => {
                if (slider.clientWidth > 532) {
                    slider.style.height = slider.clientWidth*0.33 + 40 + 'px';
                } else {
                    slider.style.height = slider.clientWidth*2.3 + 40 + 'px';
                }
            })

            if (slider.clientWidth > 532) {
                slider.style.height = slider.clientWidth*0.33 + 40 + 'px';
            } else {
                slider.style.height = slider.clientWidth*2.3 + 40 + 'px';
            }

            

            let counter = 0;
            let newcounter = 0;
            let back = false;

            dots.forEach(dot => {
                dot.addEventListener('click', () => {

                    newcounter = dot.dataset.id;
                    back = ( +counter - +newcounter) > 0;
                    this.switchSlide(slides, dots, +counter, +newcounter, back, dot)
                    counter = +newcounter;
                })
            })

            let time = 3000;

            if (slider.dataset.timer > 1000) {           
                time = slider.dataset.timer;
            }

            next.addEventListener('click', () => {

                if (counter >= slides.length - 1) {
                    newcounter = 0;
                } else {
                    newcounter = +counter + 1;
                }

                this.switchSlide(slides, dots, +counter, newcounter, false);
                counter = newcounter;
            })


            prev.addEventListener('click', () => {
                if (counter == 0) {
                    newcounter = slides.length - 1 ;
                } else {
                    newcounter = +counter - 1;
                }

                this.switchSlide(slides, dots, +counter, newcounter, true);
                counter = newcounter;
            })

            if (slides.length > 1) {

                let deleteInt = setInterval(() => {

                    if (counter >= slides.length - 1) {
                        newcounter = 0;
                    } else {
                        newcounter = +counter + 1;
                    }

                    this.switchSlide(slides, dots, +counter, newcounter);
                    counter = +newcounter;
    
                }, time)

                slider.addEventListener('mouseover', () => {
                    clearInterval(deleteInt)
                })

                slider.addEventListener('mouseleave', () => {
                    deleteInt = setInterval(() => {

                        if (counter >= slides.length - 1) {
                            newcounter = 0;
                        } else {
                            newcounter = +counter + 1;
                        }
                        
                        this.switchSlide(slides, dots, +counter, newcounter);
                        counter = +newcounter;
        
                    }, time)
                })
            }


        }

    }

    switchSlide(slides, dots, counter, newcounter, back = false) {

        
        if (!slides[newcounter]) {
            newcounter = counter;
        } 
        dots.forEach(item => {
            item.classList.remove('control-item--active')
        })

        if (back) {
            slides[counter].style.animation = 'next3 0.5s ease-in forwards'   
            slides[newcounter].style.animation = 'next4 0.5s ease-in forwards'
            
        } else {
            slides[counter].style.animation = 'next1 0.5s ease-in forwards'   
            slides[newcounter].style.animation = 'next2 0.5s ease-in forwards'
        }


        dots[newcounter].classList.add('control-item--active')    

        
    }

    addListeners() {
        const slider = document.getElementById('slider')

        if (slider) {
            window.addEventListener('load', this.initSlider)
            window.addEventListener('resize', this.recalculateWidth)
        }
    }
    recalculateWidth = () => {
        const videoList = slider.querySelector('.video-list');
        const videos = slider.querySelectorAll('.video-item');

        videos.forEach(video => {

            if (videoList.clientWidth > 900) {
                video.style.width = (videoList.clientWidth - 64)/3 + 'px';
            } else if (videoList.clientWidth > 600) {
                video.style.width = (videoList.clientWidth - 32)/2 + 'px';
            } else {
                video.style.width = videoList.clientWidth + 'px';
            }
            
        })

    }

    initSlider = () => {
        const buttons = slider.querySelectorAll('.slide-button');
        const videoList = slider.querySelector('.video-list');
        const videos = slider.querySelectorAll('.video-item');
        const ebModal = document.getElementById('mySizeChartModal');

        videoList.scrollLeft = 0;

        videos.forEach(video => {

            if (videoList.clientWidth > 900) {
                video.style.width = (videoList.clientWidth - 64)/3 + 'px';
            } else if (videoList.clientWidth > 600) {
                video.style.width = (videoList.clientWidth - 32)/2 + 'px';
            } else {
                video.style.width = videoList.clientWidth + 'px';
            }
            
            

            video.addEventListener('click', () => {
                ebModal.style.display = "block";
                const url = video.dataset.url;
                this.changeUrl(url);
            })
        })

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const scrollAmount = this.calculateScroll(videoList.clientWidth, button.dataset.id);
                videoList.scrollBy({left: scrollAmount, behavior: 'smooth'});
                button.classList.add('slide-button--checked')
            })
        })
    }

    changeUrl(url) {
        const youtube = document.getElementById('activeVideo');

        if (youtube) {
            youtube.src = 'https://www.youtube.com/embed/' + url;
        }
    }
    
    calculateScroll(width, id) {
        const buttons = slider.querySelectorAll('.slide-button');
        let active = 0;
        buttons.forEach(button => {
            if (button.classList.contains('slide-button--checked')) {
                active = button.dataset.id
                button.classList.remove('slide-button--checked')
            }
        })

        let scroll = 1;

        width = width + 32;

        if (width > 900) {
            scroll = (width * (id - active)) / 3;
        } else if (width > 600) {
            scroll = (width * (id - active)) / 2;
        } else {
            scroll = width * (id - active);
        }
    

        return scroll
    }
}

export default Slider